import React from "react"
import {InjectedIntl} from "react-intl"
import {injectIntl} from "./injectIntl"

const intlContext = React.createContext<InjectedIntl | null>(null)

export const IntlHookProvider = injectIntl(function IntlHookProviderWrapper({children, ...intl}) {
  return <intlContext.Provider value={intl.intl}>{children}</intlContext.Provider>
})

/**
 * Hook to provide react-intl utilities like `formatMessage` and `formatNumber`
 *
 * Note, you should always favour components like `FormattedMessage` and other `Formatted*`
 * components as these have additional adjustments to align with the perkbox domain
 */
export function useIntl() {
  const context = React.useContext(intlContext)
  if (!context) throw new Error("useIntl must be used inside of a IntlHookProvider")

  return context
}
